import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../context/Context";

const Login = () => {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [, setUserData] = useContext(UserContext);
  const navigate = useNavigate();
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const loginRes = await axios.post(`${apiBaseUrl}/api/users/login`, {
        email: form.email,
        password: form.password,
      });

      setUserData({
        token: loginRes.data.token,
        user: loginRes.data.user,
      });

      localStorage.setItem("auth-token", loginRes.data.token);
      navigate("/");
    } catch (err) {
      const message =
        err?.response?.data?.msg || "Login failed. Please try again.";
      setErrorMessage(message);
      console.log("Login failed:", message);
    }
  };

  return (
    <div className="bg-gray-100 md:inline-flex lg:inline-flex items-center justify-center w-full p-6">
      <div className="bg-white rounded-md md:shadow-2xl p-12 w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4">Welcome back</h1>
        <Link to="/signup" className="text-blue-500">
          Don&apos;t have an account?
        </Link>

        {errorMessage ? (
          <p className="text-red-600 text-sm mt-3">{errorMessage}</p>
        ) : null}

        <form onSubmit={handleSubmit} className="mt-4">
          <div className="mb-3">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div className="mb-4">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <button
            className="bg-blue-500 text-white p-2 rounded hover:bg-orange-400 w-full"
            type="submit"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
